import CustomAntSelect from 'general/components/CustomAntSelect'
import GoodsAutoComplete from '../Components/AutoComplete/GoodsAutoComplete'
import BaseTextFieldNoFormik from 'general/components/Forms/BaseTextFieldNoFormik'
import { Button, Typography } from 'antd'
import Select from 'react-select'

import { LockOutlined, UnlockOutlined } from '@ant-design/icons'
import InputNumberNoFormik from 'general/components/Forms/InputNumerNoFormik'
import SelectOptions from 'general/constants/SelectOptions'
import _ from 'lodash'
import Utils from 'general/utils/Utils'
import customSelectTableCellStyle from 'assets/styles/customSelectTableCellStyle'
import { PRODUCT_PROPERTY } from 'general/constants/AppConstants'
import { useState } from 'react'

export const getColumns = ({
  isDeliveryBill,
  formik,
  onSelectProduct,
  handleChangeProductNameTableData,
  onChangeTableData,
  setIsChangeTaxRate,
  persistent,
  checkedHHDV,
  handleChangeTypeTableData,
  setInputValue,
  setPersistent,
  isAdjustInvoice,
  handleOnActualExportBlur,
  invoiceSetting,
  formatNumber,
  tableDetailExtendFields,
  tableData,
  handleAddRow,
  handleRemoveRow,
  currentTemplate,
  invoiceTemplateDetail,
  rowHeight,
  setRowHeight,
  dataInvoiceTemplate,
}) => {
  // const [rowHeight, setRowHeight] = useState()
  let ret = [
    {
      title: 'STT',
      dataIndex: 'no',
      key: 'STT',
      width: 10,
      align: 'center',
      render: (text, row) => (
        <div className="d-flex justify-content-center">{row.no}</div>
      ),
    },
    {
      title: 'Tính chất HHDV',
      hidden: !checkedHHDV,
      dataIndex: 'type',
      key: 'type',
      width: 80,
      align: 'center',
      render: (_name, row) => (
        <CustomAntSelect
          options={
            isDeliveryBill
              ? SelectOptions.typeOfGoodInDeliveryBill
              : SelectOptions.typeOfGood
          }
          // need to refactor
          value={
            row?.type
              ? _.find(SelectOptions.typeOfGood, { value: row?.type })
              : SelectOptions.typeOfGood[0]
          }
          placeholder="Chọn tính chất hhdv"
          allowClear={false}
          showSearch={false}
          onChange={(value) => handleChangeTypeTableData(value, row)}
          showArrow={false}
          bordered={false}
        />
      ),
    },
    {
      title: 'Mã hàng',
      dataIndex: 'inventoryItemCode',
      width: 60,
      align: 'center',
      hidden: isDeliveryBill,
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <BaseTextFieldNoFormik
            showBorder={false}
            disabled={row?.type === 4 ? true : false}
            rounded={row?.type === 4 ? false : true}
            transparent={row?.type === 4 ? false : true}
            textAlign={'center'}
            inputValue={row.inventoryItemCode}
            onChange={(e) => {
              onChangeTableData(e, row, 'inventoryItemCode')
            }}
            value={row?.inventoryItemCode}
          />
        </div>
      ),
    },
    {
      title: isDeliveryBill
        ? 'Tên nhãn hiệu, quy cách, phẩm chất vật tư'
        : 'Tên hàng hoá/Dịch vụ',
      dataIndex: 'good_name',
      key: 'good_name',
      width: 200,
      align: 'center',
      onCell: (row, index) => ({
        style: {
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          verticalAlign: 'top', // đầu dòng bám trên cho đẹp
          height: rowHeight?.[index],
        },
      }),
      render: (_, row, index) => (
        <GoodsAutoComplete
          name={'good_name'}
          rowData={row}
          onChangeHandler={onSelectProduct}
          onBlurHandler={handleChangeProductNameTableData}
          setRowHeight={setRowHeight}
          rowIndex={index}
        />
      ),
    },
    {
      title: 'Biển kiểm soát',
      dataIndex: 'plateNumber',
      key: 'plateNumber',
      hidden: !invoiceTemplateDetail?.isDeliveryInvoice,
      width: 80,
      align: 'center',
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <BaseTextFieldNoFormik
            showBorder={false}
            value={row?.plateNumber || ''}
            onChange={(e) => {
              onChangeTableData(e, row, 'plateNumber')
            }}
            // chỉ cho phép sửa khi đó là hóa đơn đặc trưng dịch vụ vận chuyển
            disabled={
              row?.type == PRODUCT_PROPERTY.SPECIAL_GOODS &&
              invoiceTemplateDetail.isDeliveryInvoice
                ? false
                : true
            }
            inputValue={row?.plateNumber}
          />
        </div>
      ),
    },
    {
      title: 'Mã số',
      dataIndex: 'inventoryItemCode',
      width: 120,
      align: 'center',
      hidden: !isDeliveryBill,
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <BaseTextFieldNoFormik
            showBorder={false}
            disabled={row?.type === 4 ? true : false}
            rounded={row?.type === 4 ? false : true}
            transparent={row?.type === 4 ? false : true}
            textAlign={'center'}
            inputValue={row.inventoryItemCode}
            onChange={(e) => {
              onChangeTableData(e, row, 'inventoryItemCode')
            }}
            value={row?.inventoryItemCode}
          />
        </div>
      ),
    },
    {
      title: 'Quy cách',
      dataIndex: 'specification',
      width: 120,
      align: 'center',
      hidden:
        (isDeliveryBill && formik.values?.invoiceType === 'N') ||
        !isDeliveryBill,
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <BaseTextFieldNoFormik
            showBorder={false}
            value={row?.specification || ''}
            disabled={row?.type === 4 ? true : false}
            rounded={row?.type === 4 ? false : true}
            transparent={row?.type === 4 ? false : true}
            textAlign={'center'}
            inputValue={row.specification}
            onChange={(e) => {
              onChangeTableData(e, row, 'specification')
            }}
          />
        </div>
      ),
    },
    {
      title: 'Số khung',
      dataIndex: 'chassisNumber',
      key: 'chassisNumber',
      width: 60,
      align: 'center',
      hidden:
        currentTemplate?.category?.form == 3
          ? !invoiceTemplateDetail?.chassisNumber
          : currentTemplate?.category?.code !== 'BX',
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <BaseTextFieldNoFormik
            onChange={(e) => {
              setInputValue(e.target.value)
              onChangeTableData(e, row, 'chassisNumber')
            }}
            showBorder={false}
            value={row?.chassisNumber || ''}
            disabled={
              row?.type == PRODUCT_PROPERTY.SPECIAL_GOODS &&
              currentTemplate?.category?.code === 'BX'
                ? false
                : true
            }
            // rounded={row?.type === 4 ? false : true}
            transparent={row?.type === 4 ? false : true}
            textAlign={'center'}
            inputValue={row.chassisNumber}
            // multiLine={true}
          />
        </div>
      ),
    },
    {
      title: 'Số máy',
      dataIndex: 'engineNumber',
      key: 'engineNumber',
      width: 60,
      align: 'center',
      hidden:
        currentTemplate?.category?.form == 3
          ? !invoiceTemplateDetail?.engineNumber
          : currentTemplate?.category?.code !== 'BX',
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <BaseTextFieldNoFormik
            onChange={(e) => {
              setInputValue(e.target.value)
              onChangeTableData(e, row, 'engineNumber')
            }}
            showBorder={false}
            value={row?.engineNumber || ''}
            disabled={
              row?.type == PRODUCT_PROPERTY.SPECIAL_GOODS &&
              currentTemplate?.category?.code === 'BX'
                ? false
                : true
            }
            rounded={row?.type === 4 ? false : true}
            transparent={row?.type === 4 ? false : true}
            textAlign={'center'}
            inputValue={row.engineNumber}
            // multiLine={true}
          />
        </div>
      ),
    },
    {
      title: 'ĐVT',
      dataIndex: 'unit',
      key: 'unit',
      width: 60,
      align: 'center',
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <BaseTextFieldNoFormik
            onChange={(e) => {
              setInputValue(e.target.value)
              onChangeTableData(e, row, 'unit')
            }}
            showBorder={false}
            value={row?.unit || ''}
            disabled={row?.type === 4 ? true : false}
            rounded={row?.type === 4 ? false : true}
            transparent={row?.type === 4 ? false : true}
            textAlign={'center'}
            inputValue={row.unit}
            // multiLine={true}
          />
        </div>
      ),
    },
    {
      title: (
        <div className="d-flex flex-column align-items-center">
          <Button
            type="text"
            shape="circle"
            className="align-self-end"
            icon={
              persistent === 'quantityPersistent' ? (
                <LockOutlined />
              ) : (
                <UnlockOutlined />
              )
            }
            onClick={() => {
              setPersistent((prev) =>
                prev === 'quantityPersistent'
                  ? 'priceAfterTaxPersistent'
                  : 'quantityPersistent',
              )
            }}
          ></Button>

          <Typography.Title level={5} className="">
            Số lượng
          </Typography.Title>
        </div>
      ),
      dataIndex: 'quantity',
      key: 'quantity',
      width: 100,
      align: 'center',
      hidden: isDeliveryBill && formik.values?.invoiceType === 'N',
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <InputNumberNoFormik
            systemConfigType="quantity"
            showBorder={false}
            onChange={(e) => {
              setIsChangeTaxRate(true)
              onChangeTableData(e, row, 'quantity', 'number')
            }}
            value={row?.quantity}
            disabled={row?.type === 4 ? true : false}
            transparent={row?.type === 4 ? false : true}
            rounded={row?.type === 4 ? false : true}
            textAlign={'center'}
            allowNegative={isAdjustInvoice ? true : false}
          />
        </div>
      ),
    },
    {
      title: 'Số lượng',
      width: 120,
      align: 'center',
      // CHỉ hiển thị khi đó là phiếu xuất kho nội bộ
      hidden: !isDeliveryBill || formik.values?.invoiceType === 'B',
      children: [
        {
          title: 'Thực xuất',
          width: 60,
          align: 'center',
          render: (_, row) => (
            <div className="w-100 input-table-cover">
              <InputNumberNoFormik
                additionalInputClassName={'pr-5'}
                systemConfigType="quantity"
                showBorder={false}
                onChange={(e) => {
                  onChangeTableData(e, row, 'actualExport', 'number')
                }}
                onBlur={(e) => handleOnActualExportBlur(e, row)}
                value={row?.actualExport}
                disabled={row?.type === 4 ? true : false}
                transparent={row?.type === 4 ? false : true}
                rounded={row?.type === 4 ? false : true}
                textAlign={'right'}
                allowNegative={isAdjustInvoice ? true : false}
              />
            </div>
          ),
        },
        {
          title: 'Thực nhập',
          width: 60,
          align: 'center',
          render: (_, row) => (
            <div className="w-100 input-table-cover">
              <InputNumberNoFormik
                additionalInputClassName={'pr-5'}
                systemConfigType="quantity"
                showBorder={false}
                onChange={(e) => {
                  onChangeTableData(e, row, 'actualImport', 'number')
                }}
                value={row?.actualImport}
                disabled={row?.type === 4 ? true : false}
                transparent={row?.type === 4 ? false : true}
                rounded={row?.type === 4 ? false : true}
                textAlign={'right'}
                allowNegative={isAdjustInvoice ? true : false}
              />
            </div>
          ),
        },
      ],
    },
    {
      title: () => (
        <div className="d-flex flex-column align-items-center">
          <Button
            type="text"
            shape="circle"
            className="align-self-end"
            icon={
              persistent === 'priceAfterTaxPersistent' ? (
                <LockOutlined />
              ) : (
                <UnlockOutlined />
              )
            }
            onClick={() => {
              setPersistent((prev) =>
                prev === 'priceAfterTaxPersistent'
                  ? 'quantityPersistent'
                  : 'priceAfterTaxPersistent',
              )
            }}
          ></Button>
          <Typography.Title level={5} className="">
            Đơn giá sau thuế
          </Typography.Title>
        </div>
      ),
      dataIndex: 'unitPriceAfterTax',
      hidden: !invoiceSetting?.priceAfterTax || isDeliveryBill,
      width: 120,
      align: 'center',
      render: (_, row) => (
        <div className="w-100 input-table-cover column-money">
          <InputNumberNoFormik
            systemConfigType={
              // 'unitPrice'
              !['VNĐ', 'VND'].includes(formik.values.currency)
                ? 'currencyUnitPrice'
                : 'unitPrice'
            }
            showBorder={false}
            // onValueChange={(e, sourceInfo) => {
            //   if (sourceInfo.source === 'event') {
            //     onChangeTableData(e, row, 'unitPriceAfterTax', 'number')
            //   }
            // }}
            onChange={(e) => {
              setIsChangeTaxRate(true)
              onChangeTableData(e, row, 'unitPriceAfterTax', 'number')
            }}
            value={row?.unitPriceAfterTax}
            disabled={row?.type === 4 ? true : false}
            transparent={row?.type === 4 ? false : true}
            rounded={row?.type === 4 ? false : true}
            textAlign={'right'}
            allowNegative={isAdjustInvoice ? true : false}
            additionalInputClassName={'pr-5'}
          />
        </div>
      ),
    },
    {
      title: 'Thành tiền sau thuế',
      dataIndex: 'totalUnitPriceAfterTax',
      key: 'totalUnitPriceAfterTax',
      hidden: !invoiceSetting?.priceAfterTax || isDeliveryBill,
      width: 100,
      align: 'right',
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <InputNumberNoFormik
            additionalInputClassName={'pr-5'}
            systemConfigType={
              // 'currencyExchange'
              !['VNĐ', 'VND'].includes(formik.values.currency)
                ? 'foreignCurrency'
                : 'currencyExchange'
            }
            showBorder={false}
            onChange={(e) => {
              setIsChangeTaxRate(true)
              onChangeTableData(e, row, 'totalUnitPriceAfterTax', 'number')
            }}
            value={row?.totalUnitPriceAfterTax}
            disabled={row?.type === 4 ? true : false}
            transparent={row?.type === 4 ? false : true}
            rounded={row?.type === 4 ? false : true}
            textAlign={'right'}
            allowNegative={isAdjustInvoice ? true : false}
          />
        </div>
      ),
    },
    {
      title: 'Đơn giá',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      width: 90,
      align: 'right',
      render: (_, row) => (
        <div className="w-100 input-table-cover column-money">
          <InputNumberNoFormik
            systemConfigType={
              !['VNĐ', 'VND'].includes(formik.values.currency)
                ? 'currencyUnitPrice'
                : 'unitPrice'
            }
            // systemConfigType={
            //   formik.values.exchangeRate !== 1 ? 'currencyExchange' : null
            // }
            showBorder={false}
            // onValueChange={(e, sourceInfo) => {
            //   if (sourceInfo.source === 'event') {
            //     onChangeTableData(e, row, 'unitPrice', 'number')
            //   }
            // }}
            onChange={(e) => {
              setIsChangeTaxRate(true)
              onChangeTableData(e, row, 'unitPrice', 'number')
            }}
            additionalInputClassName={'pr-5'}
            value={row?.unitPrice}
            disabled={row?.type === 4 ? true : false}
            transparent={row?.type === 4 ? false : true}
            rounded={row?.type === 4 ? false : true}
            textAlign={'right'}
            allowNegative={isAdjustInvoice ? true : false}
          />
        </div>
      ),
    },
    {
      title: 'Thành tiền',
      dataIndex: 'totalUnitPrice',
      key: 'totalUnitPrice',
      width: 100,
      align: 'right',
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <InputNumberNoFormik
            systemConfigType={
              !['VNĐ', 'VND'].includes(formik.values.currency)
                ? 'foreignCurrency'
                : 'currencyExchange'
            }
            showBorder={false}
            // onValueChange={(e, sourceInfo) => {
            //   if (sourceInfo.source === 'event') {
            //     onChangeTableData(e, row, 'totalUnitPrice', 'number')
            //   }
            // }}
            onChange={(e) => {
              setIsChangeTaxRate(true)
              onChangeTableData(e, row, 'totalUnitPrice', 'number')
            }}
            additionalInputClassName={'pr-5'}
            value={row?.totalUnitPrice}
            disabled={row?.type === 4 ? true : false}
            transparent={row?.type === 4 ? false : true}
            rounded={row?.type === 4 ? false : true}
            textAlign={'right'}
            allowNegative={isAdjustInvoice ? true : false}
          />
        </div>
      ),
    },
  ]
  ret = ret.filter((item) => !item.hidden)

  // thành tiền quy đổi
  if (formik.values.currency !== 'VNĐ' && formik.values.currency !== 'VND') {
    ret.push({
      title: 'Thành tiền quy đổi',
      dataIndex: 'exchangedTotalUnitPrice',
      key: 'exchangedTotalUnitPrice',
      width: 100,
      align: 'right',
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <InputNumberNoFormik
            systemConfigType={
              'currencyExchange'
              // !['VNĐ', 'VND'].includes(formik.values.currency)
              //   ? 'foreignCurrency'
              //   : 'currencyExchange'
            }
            showBorder={false}
            // onValueChange={(e, sourceInfo) => {
            //   if (sourceInfo.source === 'event') {
            //     onChangeTableData(
            //       e,
            //       row,
            //       'exchangedTotalUnitPrice',
            //       'number',
            //     )
            //   }
            // }}
            onChange={(e) => {
              setIsChangeTaxRate(true)
              onChangeTableData(e, row, 'exchangedTotalUnitPrice', 'number')
            }}
            value={row?.exchangedTotalUnitPrice || 0}
            // disabled={formik.values.autoCalculate}
            disabled={true}
            transparent={false}
            rounded={false}
            textAlign={'right'}
            allowNegative={isAdjustInvoice ? true : false}
          />
        </div>
      ),
    })
  }

  // tỉ lệ và tiền chiết khấu
  if (formik.values.discountType === 1) {
    ret.push(
      {
        title: 'Tỉ lệ CK (%)',
        key: '',
        width: 130,
        align: 'center',
        render: (_, row) => (
          <div className="w-100 input-table-cover">
            <InputNumberNoFormik
              systemConfigType="ratio"
              showBorder={false}
              maxLength={formatNumber?.ratio + 4}
              // format={Utils.limitIntergerPath}
              // onValueChange={(e, sourceInfo) => {
              //   if (sourceInfo.source === 'event') {
              //     if (e?.floatValue > 100) {
              //       e.floatValue = 100
              //       e.formattedValue = '100'
              //       e.value = '100'
              //     }
              //     if (e?.floatValue < 0) {
              //       e.floatValue = 0
              //       e.formattedValue = '0'
              //       e.value = '0'
              //     }

              //     onChangeTableData(e, row, 'discount', 'number')
              //   }
              // }}
              onChange={(e) => {
                if (Utils.parseFormattedNumberToFloat(e.target?.value) > 100) {
                  e.target.value = '100'
                }
                if (Utils.parseFormattedNumberToFloat(e?.floatValue) < 0) {
                  e.target.value = '0'
                }
                setIsChangeTaxRate(true)
                onChangeTableData(e, row, 'discount', 'number')
              }}
              // onBlur={(e) => {
              //   console.log(e)
              //   if (Utils.parseFormattedNumberToFloat(e.target.value) > 100) {
              //     e.target.value = '100'
              //   }
              //   if (Utils.parseFormattedNumberToFloat(e?.floatValue) < 0) {
              //     e.target.value = '0'
              //   }
              //   onChangeTableData(e, row, 'discount', 'number')
              // }}
              value={row?.discount}
              disabled={row?.type === 4 || row?.type === 3 ? true : false}
              transparent={row?.type === 4 || row?.type === 3 ? false : true}
              rounded={row?.type === 4 || row?.type === 3 ? false : true}
              textAlign={'center'}
              allowNegative={isAdjustInvoice ? true : false}
            />
          </div>
        ),
      },
      {
        title: 'Tiền CK',
        key: '',
        width: 100,
        align: 'center',
        render: (_, row) => (
          <div className="w-100 input-table-cover">
            <InputNumberNoFormik
              systemConfigType={
                !['VNĐ', 'VND'].includes(formik.values.currency)
                  ? 'foreignCurrency'
                  : 'currencyExchange'
                // !['VNĐ', 'VND'].includes(formik.values.currency)
                //   ? 'foreignCurrency'
                //   : 'currencyExchange'
              }
              showBorder={false}
              // onValueChange={(e, sourceInfo) => {
              //   if (sourceInfo.source === 'event') {
              //     onChangeTableData(e, row, 'discountMoney', 'number')
              //   }
              // }}
              onChange={(e) => {
                setIsChangeTaxRate(true)
                onChangeTableData(e, row, 'discountMoney', 'number')
              }}
              value={row?.discountMoney}
              disabled={row?.type === 4 || row?.type === 3 ? true : false}
              transparent={row?.type === 4 || row?.type === 3 ? false : true}
              rounded={row?.type === 4 || row?.type === 3 ? false : true}
              textAlign={'center'}
              allowNegative={isAdjustInvoice ? true : false}
            />
          </div>
        ),
      },
    )
  }

  // Tiền CK quy đổi
  if (
    formik.values.currency !== 'VNĐ' &&
    formik.values.currency !== 'VND' &&
    formik.values.discountType === 1
  ) {
    ret.push({
      title: 'Tiền CK quy đổi',
      width: 200,
      align: 'center',
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <InputNumberNoFormik
            systemConfigType="currencyExchange"
            showBorder={false}
            // onValueChange={(e, sourceInfo) => {
            //   if (sourceInfo.source === 'event') {
            //     onChangeTableData(
            //       e,
            //       row,
            //       'exchangedDiscountMoney',
            //       'number',
            //     )
            //   }
            // }}
            onChange={(e) => {
              setIsChangeTaxRate(true)
              onChangeTableData(e, row, 'exchangedDiscountMoney', 'number')
            }}
            value={row?.exchangedDiscountMoney || 0}
            // disabled={formik.values.autoCalculate}
            disabled={true}
            transparent={false}
            rounded={false}
            textAlign={'center'}
            allowNegative={isAdjustInvoice ? true : false}
          />
        </div>
      ),
    })
  }

  if (
    parseInt(formik.values?.serial?.charAt(0)) === 2 &&
    formik.values.isTaxReduction === true
  ) {
    ret.push({
      title: `% Tính thuế`,
      width: 100,
      align: 'center',
      render: (_, row) => (
        <Select
          styles={customSelectTableCellStyle}
          className="w-100"
          classNamePrefix="select"
          options={SelectOptions.TaxReductionRate}
          value={
            row?.taxReductionRate != null
              ? SelectOptions.TaxReductionRate.find(
                  (option) =>
                    option.value.toString() ===
                    row?.taxReductionRate.toString(),
                )
              : SelectOptions.TaxReductionRate[0]
          }
          onChange={(selectedOption) => {
            setIsChangeTaxRate(true)
            onChangeTableData(
              selectedOption,
              row,
              'taxReductionRate',
              'taxReductionRate',
            )
          }}
          // defaultValue={SelectOptions.typeOfGood[0]}
          name="color"
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator: () => null,
          }}
          menuPortalTarget={document.querySelector('body')}
          menuPosition="fixed"
          menuPlacement="auto"
          isDisabled={row?.type === 4 ? true : false}
        />
      ),
    })

    ret.push({
      title: 'Tiền thuế GTGT được giảm',
      key: '',
      width: 120,
      align: 'center',
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <InputNumberNoFormik
            systemConfigType={
              !['VNĐ', 'VND'].includes(formik.values.currency)
                ? 'foreignCurrency'
                : 'currencyExchange'
              // !['VNĐ', 'VND'].includes(formik.values.currency)
              //   ? 'foreignCurrency'
              //   : 'currencyExchange'
            }
            showBorder={false}
            // onValueChange={(e, sourceInfo) => {
            //   if (sourceInfo.source === 'event') {
            //     onChangeTableData(e, row, 'taxReduction', 'number')
            //   }
            // }}
            onChange={(e) => {
              setIsChangeTaxRate(true)
              onChangeTableData(e, row, 'taxReduction', 'number')
            }}
            value={row?.taxReduction}
            disabled={formik.values.autoCalculate}
            transparent={row?.type === 4 ? false : true}
            rounded={row?.type === 4 ? false : true}
            textAlign={'right'}
            allowNegative={isAdjustInvoice ? true : false}
          />
        </div>
      ),
    })
    if (formik.values.currency !== 'VNĐ' && formik.values.currency !== 'VND') {
      ret.push({
        title: 'Tiền thuế GTGT được giảm quy đổi',
        key: '',
        width: 120,
        align: 'center',
        render: (_, row) => (
          <div className="w-100 input-table-cover">
            <InputNumberNoFormik
              systemConfigType={
                'currencyExchange'
                // !['VNĐ', 'VND'].includes(formik.values.currency)
                //   ? 'foreignCurrency'
                //   : 'currencyExchange'
              }
              showBorder={false}
              // onValueChange={(e, sourceInfo) => {
              //   if (sourceInfo.source === 'event') {
              //     onChangeTableData(e, row, 'taxReduction', 'number')
              //   }
              // }}
              value={row?.taxReductionExchange}
              disabled={true}
              transparent={row?.type === 4 ? false : true}
              rounded={row?.type === 4 ? false : true}
              textAlign={'right'}
              allowNegative={isAdjustInvoice ? true : false}
            />
          </div>
        ),
      })
    }
  }

  // Hiển thị % thuế và tiền thuế
  if (
    parseInt(formik.values?.serial?.charAt(0)) === 1 &&
    (formik.values.taxType === 2 ||
      (formik.values.taxType === 3 && formik.values.multipleTaxRate))
  ) {
    ret.push({
      title: '% Thuế',
      width: 100,
      align: 'center',
      render: (_, row) => (
        <Select
          styles={customSelectTableCellStyle}
          className="w-100"
          classNamePrefix="select"
          options={SelectOptions.GTGT}
          value={
            row?.taxRate
              ? SelectOptions.GTGT.find(
                  (option) =>
                    option.value.toString() === row?.taxRate.toString(),
                )
              : SelectOptions.GTGT[0]
          }
          onChange={(selectedOption) => {
            console.log(selectedOption.value, row?.taxRate)
            if (selectedOption.value != row?.taxRate) {
              setIsChangeTaxRate(true)
            }
            onChangeTableData(selectedOption, row, 'taxRate', 'taxRate')
          }}
          // defaultValue={SelectOptions.typeOfGood[0]}
          name="color"
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator: () => null,
          }}
          menuPortalTarget={document.querySelector('body')}
          menuPosition="fixed"
          menuPlacement="auto"
          isDisabled={row?.type === 4 ? true : false}
        />
      ),
    })

    ret.push({
      title: 'Tiền thuế',
      key: '',
      width: 120,
      align: 'center',
      render: (_, row) => (
        <div className="w-100 input-table-cover">
          <InputNumberNoFormik
            systemConfigType={
              !['VNĐ', 'VND'].includes(formik.values.currency)
                ? 'foreignCurrency'
                : 'currencyExchange'
            }
            showBorder={false}
            // onValueChange={(e, sourceInfo) => {
            //   if (sourceInfo.source === 'event') {
            //     onChangeTableData(e, row, 'taxMoney', 'number')
            //   }
            // }}
            onChange={(e) => {
              setIsChangeTaxRate(true)
              onChangeTableData(e, row, 'taxMoney', 'number')
            }}
            value={row?.taxMoney}
            // disabled={row?.taxRate === 'KHAC' || autoCalculate ? false : true}
            // disabled={false}
            disabled={
              // Chỉ cho phép sửa khi tắt bút tự động tính hoặc % thuế là khác
              formik.values.autoCalculate && row?.taxRate != 'KHAC'
            }
            transparent={row?.type === 4 ? false : true}
            rounded={row?.type === 4 ? false : true}
            textAlign={'right'}
            allowNegative={isAdjustInvoice ? true : false}
          />
        </div>
      ),
    })
    if (formik.values.currency !== 'VNĐ' && formik.values.currency !== 'VND') {
      ret.push({
        title: 'Tiền thuế quy đổi',
        key: '',
        width: 120,
        align: 'right',
        render: (_, row) => (
          <div className="w-100 input-table-cover">
            <InputNumberNoFormik
              systemConfigType="currencyExchange"
              showBorder={false}
              onChange={(e) => {
                setIsChangeTaxRate(true)
                onChangeTableData(e, row, 'exchangedTaxMoney', 'number')
              }}
              value={row?.exchangedTaxMoney}
              // disabled={row?.taxRate === 'KHAC' ? false : true}
              disabled={true}
              transparent={row?.type === 4 ? false : true}
              rounded={row?.type === 4 ? false : true}
              textAlign={'right'}
              allowNegative={isAdjustInvoice ? true : false}
            />
          </div>
        ),
      })
    }
  }

  tableDetailExtendFields.forEach((item) => {
    if (item?.forceShow || item?.show) {
      ret.push({
        title: item.label,
        dataIndex: item.name,
        key: item.name,
        // width: 100,
        align: 'center',
        render: (_, row) => (
          <div className="w-100 input-table-cover">
            <BaseTextFieldNoFormik
              // onChange={(e) => {
              //   onChangeTableData(e, row, item.name)
              // }}
              onChange={(e) => {
                onChangeTableData(e, row, item.name)
              }}
              transparent={true}
              showBorder={false}
              inputValue={
                row[item.name]?.value ??
                row[item.name]?.defaultValue ??
                item.defaultValue
              }
            />
          </div>
        ),
      })
    }
  })

  ret.push({
    title: '',
    dataIndex: 'option',
    key: 'option',
    width: 50,
    align: 'center',
    render: (_, row, index) => (
      <div className="d-flex justify-content-center">
        {/* {row.no === tableData.length && ( */}
        <div
          className="d-flex h-100 align-items-center cursor-pointer h-100 icon-table"
          style={{ zIndex: '1' }}
          onClick={() => {
            handleAddRow(row, [...tableData], index)
          }}
        >
          <i className="far fa-plus" style={{ color: 'green' }}></i>
        </div>
        {/* )} */}
        <div
          className="d-flex h-100 align-items-center cursor-pointer h-100 icon-table ml-1"
          style={{ zIndex: '1' }}
          onClick={() => {
            if (tableData.length !== 1) {
              handleRemoveRow(row)
            }
          }}
        >
          <i className="far fa-trash-alt" style={{ color: 'red' }}></i>
        </div>
      </div>
    ),
  })

  return ret
}
